import { useMemo } from 'react'

const useSelectOptionsAmount = ({
  total,
  unit,
  startIndex = 1,
  unitString,
  initValue = [],
}: {
  total: number
  unit: number
  startIndex?: number
  unitString?: string
  initValue?: number[]
}) => {
  return useMemo(() => {
    const baseOptions = Array.from({ length: total }, (_, i) => {
      const baseValue = (i + startIndex) * unit
      return {
        label: unitString ? baseValue + unitString : baseValue.toString(),
        value: baseValue.toString(),
      }
    })
    const initOptions = initValue.map((initValue) => ({
      label: unitString ? initValue + unitString : initValue.toString(),
      value: initValue.toString(),
    }))
    return [...initOptions, ...baseOptions]
  }, [total, unit, startIndex, unitString, initValue])
}

export default useSelectOptionsAmount
